import { Sun, Moon, Heart } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@context/AuthContext';
import { useTheme } from '@context/ThemeContext';
import Logo from '@components/ui/Logo';

const Header = ({ rightAction }) => {
  const { user } = useAuth();
  const { dark, toggleTheme } = useTheme();
  const logoTo = user ? '/feed' : '/';

  return (
    <header className="sticky top-0 z-40 glass-header">
      <div className="w-full max-w-6xl mx-auto flex items-center justify-between px-4 sm:px-6 lg:px-8 h-16">
        <Logo size="md" to={logoTo} />
        <div className="flex items-center gap-2.5">
          <NavLink
            to="/wishlist"
            className={({ isActive }) =>
              `theme-toggle shrink-0 ${
                isActive
                  ? '!bg-brand-500/15 !text-brand-600 ring-1 ring-brand-500/25 dark:!bg-brand-500/20 dark:!text-brand-400 dark:ring-brand-400/30'
                  : ''
              }`
            }
            aria-label="Wishlist"
          >
            {({ isActive }) => (
              <Heart size={18} strokeWidth={isActive ? 2.4 : 1.8} />
            )}
          </NavLink>
          <button
            onClick={toggleTheme}
            className="theme-toggle"
            aria-label="Toggle dark mode"
          >
            {dark ? <Sun size={18} strokeWidth={2} /> : <Moon size={18} strokeWidth={2} />}
          </button>
          {rightAction}
        </div>
      </div>
    </header>
  );
};

export default Header;
